import { Reveal, SectionHeading } from "./Reveal";
import { KeyRound, Code2, ArrowUpRight } from "lucide-react";
import { scrollToId } from "./Header";
import { useLang } from "@/i18n/LanguageContext";

export const WhatWeDo = () => {
  const { t } = useLang();

  const CARDS = [
    { icon: KeyRound, title: t("wwd.c1t"), desc: t("wwd.c1d"), tags: ["FIBRE QKD", "FREE-SPACE", "TRUSTED NODES"] },
    { icon: Code2, title: t("wwd.c2t"), desc: t("wwd.c2d"), tags: ["ML-KEM", "ML-DSA", "HYBRID HANDSHAKE"] },
  ];

  return (
    <section id="what-we-do" data-testid="what-we-do-section" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow={t("wwd.eyebrow")}
          title={
            <>
              {t("wwd.titleA")}
              <span className="text-blue-700">{t("wwd.titleB")}</span>
            </>
          }
          sub={t("wwd.sub")}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.1}>
              <div
                data-testid={`service-card-${i + 1}`}
                className="group relative h-full p-7 sm:p-9 rounded-2xl border border-slate-200/90 bg-slate-50/50 bg-blueprint hover:bg-white hover:border-blue-300 hover:shadow-[0_20px_48px_-18px_rgba(29,78,216,0.28)] hover:-translate-y-1 transition-all duration-400 overflow-hidden"
              >
                <div className="flex items-start justify-between">
                  <div className="grid place-items-center p-3.5 rounded-2xl bg-blue-700 text-white shadow-[0_10px_24px_-8px_rgba(29,78,216,0.5)] group-hover:scale-110 transition-transform duration-300">
                    <c.icon className="w-6 h-6" />
                  </div>
                  <button
                    data-testid={`service-cta-${i + 1}`}
                    onClick={() => scrollToId("#contact")}
                    aria-label={c.title}
                    className="grid place-items-center w-10 h-10 rounded-full border border-slate-300 text-slate-400 group-hover:border-blue-600 group-hover:text-blue-700 group-hover:rotate-45 transition-all duration-300"
                  >
                    <ArrowUpRight className="w-4 h-4" />
                  </button>
                </div>
                <h3 className="mt-6 text-xl sm:text-2xl font-bold text-slate-900 tracking-tight">{c.title}</h3>
                <p className="mt-3 text-sm sm:text-base text-slate-500 leading-relaxed">{c.desc}</p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {c.tags.map((tag) => (
                    <span key={tag} className="text-[10px] font-mono font-bold tracking-[0.14em] text-slate-500 bg-white border border-slate-200 group-hover:border-blue-200 group-hover:text-blue-700 px-2.5 py-1 rounded-full transition-colors duration-300">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
